import { Capacitor } from "@capacitor/core";
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

const Captcha = ({ reRef }) => {
  if (Capacitor.isNativePlatform()) {
    return <></>;
  } else {
    return (
      <div>
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_KEY}
          size={"invisible"}
          ref={reRef}
          badge="bottomleft"
        />
      </div>
    );
  }
};

export default Captcha;
